<template>
  <div id="app">
    <!-- <app-side-bar-big></app-side-bar-big> -->
    <app-side-bar-small></app-side-bar-small>
    <router-view/>
  </div>
</template>

<script>
// import SideBarBig from './components/SideBarBig.vue'
import SideBarSmall from './components/SideBarSmall.vue'
export default {
    components: {
        // appSideBarBig: SideBarBig,
        appSideBarSmall: SideBarSmall,
    },
}
</script>

<style lang="scss">
#app {
}
</style>
